import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/backlinks/reports/index.vue') }
}

export class NewController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/backlinks/reports/form.vue') }
}
export class EditController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/backlinks/reports/form.vue') }

  static values = {
    backlinksReportId: String
  }

  connect() {
    super.connect({
      backlinksReportId: this.backlinksReportIdValue
    })
  }
}
